const text1 = document.getElementById('embroidery_add');
const text2 = document.getElementById('embroidery_text');
if (!text1 || !text2) return;
const checkboxWrapper = document.querySelector(
  '.product-embroidery .form-field__checkbox'
);
const emojiError = document.querySelector('[data-embroidery-error]');

/** Emoji, skin tones, flags, keycaps and the joiners that combine them. */
const emojiRegex =
  /[\p{Extended_Pictographic}\p{Emoji_Presentation}\u{1F3FB}-\u{1F3FF}\u{1F1E6}-\u{1F1FF}\u{FE0F}\u{20E3}\u{200D}]/gu;

text2.addEventListener('input', () => handleInput());
text1.addEventListener('change', () => copyTextValue());

/**
 * Strips nulls and < > so the value cannot form HTML tags (incl. script) if echoed unsafely elsewhere,
 */
function sanitizeEmbroideryText(value) {
  return value.replace(/\0/g, '').replace(/[<>]/g, '').replace(emojiRegex, '');
}

function containsEmoji(value) {
  return value.replace(emojiRegex, '') !== value;
}

function copyTextValue(e) {
  const text2Value = text2.value;

  const charEL = document.querySelector('.product-embroidery_char span');

  if (checkboxWrapper) {
    if (text2Value) {
      checkboxWrapper.classList.remove('form-field__checkbox--disabled');
    } else {
      text1.checked = false;
      checkboxWrapper.classList.add('form-field__checkbox--disabled');
    }
  }

  if (charEL) charEL.innerHTML = text2Value.length;
  text1.value = text1.checked ? text2Value : '';
}

function handleInput() {
  const raw = text2.value;
  const sanitized = sanitizeEmbroideryText(raw);
  if (sanitized !== raw) {
    text2.value = sanitized;
  }
  if (emojiError) {
    emojiError.classList.toggle('is-expanded', containsEmoji(raw));
  }
  copyTextValue();
}

window.addEventListener('load', function () {
  handleInput();
});
